module.exports = __webpack_public_path__ + "img/concreted.4bd68063.png";